import { checkLockStatus } from "../services/dashboardServices";
import { lockCarePlan } from "../redux/actions/careplanActions";
export async function checkLockThen(
  carePlanId,
  userProfile,
  dispatch,
  onLocked, // what to do if locked by someone else
  onAlreadyLocked, // what to do if locked by me (e.g. extend lock)
  onProceed // what to do if not locked
) {
  try {
    const status = await checkLockStatus(carePlanId);
    if (status.is_locked && status.locked_by.id !== userProfile.id) {
      // locked by someone else → show modal or early return
      onLocked(status.locked_by);
      return false;
    }
    if (status.is_locked && status.locked_by.id === userProfile.id) {
      // already locked by me → optionally re‐lock/extend
      await dispatch(lockCarePlan(carePlanId));
      onAlreadyLocked?.();
      return true;
    }
    // not locked → acquire lock
    await dispatch(lockCarePlan(carePlanId));
    onProceed();
    return true;
  } catch (err) {
    console.error("Lock check failed", err);
    return false;
  }
}
